import React from 'react';
import CanonicalResellerOnboardingComponent from './canonical-reseller-onboarding.component';

function CanonicalResellerOnboarding() {
    return <CanonicalResellerOnboardingComponent />;
}

export default CanonicalResellerOnboarding;
